import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.contest.create')

export const handle = {
  name: 'contest-create',
  track: { scene: 'contest' },
  showAppNav: true,
}

export function loader() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
